import axios from 'axios';
import StorageHelper from "../utils/storage-helper";
import { showGlobalToast } from "../components/common/GlobalToast";

class ApiClient {
    constructor() {
        this.api = axios.create({
            baseURL: process.env.REACT_APP_DOVESAPI || ''
        });

        this.api.interceptors.request.use((config) => {
            const token = StorageHelper.get('token');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            if (!config.headers['Content-Type']) {
                config.headers['Content-Type'] = 'application/json';
            }
            return config;
        });

        this.api.interceptors.response.use(
            (response) => {
                return response;
            },
            (error) => {
                this.handleError(error);
                return Promise.reject(error);
            }
        );
    }

    handleError(error) {
        let errorMsg = 'An unexpected error occurred';
        if (error.response) {
            errorMsg = error.response.data?.message || error.response.data?.responseBody || error.response.statusText || errorMsg;
        } else if (error.message) {
            errorMsg = error.message;
        }

        showGlobalToast('error', 'Error', errorMsg);
        console.error('API Error:', errorMsg);
    }

    get(url, config = {}) {
        return this.api.get(url, config);
    }

    post(url, data = {}, config = {}) {
        return this.api.post(url, data, config);
    }

    put(url, data = {}, config = {}) {
        return this.api.put(url, data, config);
    }

    delete(url, config = {}) {
        return this.api.delete(url, config);
    }
}

const apiClient = new ApiClient();
export default apiClient;
